import React from 'react';
import { AdminRouteName } from '../../CONSTANTS';
import BillsPaymentTableRecords from '../BillsPaymentTableRecord';

const SuccessfulBillsPayment = () => (
  <div className="bills-payment-root-cover"><BillsPaymentTableRecords hasNameAndImage defaultUrl={AdminRouteName.successfulBillsPaymentRoute} tabStatus="success" toggleStorageId="successful-bills-payment-table-col" recordPermission="can-get-bills-payment" /></div>
);
export default SuccessfulBillsPayment;
